import getCreateRandomId from 'json-rpc-random-id';
export { getED25519Key } from '@web3auth/auth';

const createRandomId = getCreateRandomId();
let EIP1193_EVENTS = /*#__PURE__*/function (EIP1193_EVENTS) {
  EIP1193_EVENTS["ACCOUNTS_CHANGED"] = "accountsChanged";
  EIP1193_EVENTS["CHAIN_CHANGED"] = "chainChanged";
  EIP1193_EVENTS["CONNECT"] = "connect";
  EIP1193_EVENTS["DISCONNECT"] = "disconnect";
  EIP1193_EVENTS["MESSAGE"] = "message";
  return EIP1193_EVENTS;
}({});

export { EIP1193_EVENTS, createRandomId };
